export default defineNuxtPlugin(nuxtApp => {
  if (process.server) return
  nuxtApp.hook('app:suspense:resolve', () => {
    // @ts-ignore
    window.__SUSPENSE_RESOLVED__ = true
  })
})
